import { logout, requestNewAccessToken } from 'app-support/auth/state/actions'
import { credentials } from './utils'
import moment from 'moment'
import { Store } from 'redux'
import { getCookie } from '@cbgms/base/utils/helpers'

const tokenExpired = async ({ request, store }: { request: Function; store: Store }) => {
  const { emailAddress, token, lastRefreshRequest } = credentials(store)
  if (!lastRefreshRequest || moment().diff(lastRefreshRequest, 'minutes') >= 3) {
    // make sure we don't loop forever; only use a refresh token every 3 minutes. else force a logout
    const result = await store.dispatch(
      requestNewAccessToken(emailAddress, token, getCookie('AuthProviderAzure') === 'true' ? 'azure' : 'okta')
    )

    if (result && result.Data && result.Data.AuthenticationResult && result.Data.AuthenticationResult.AccessToken) {
      return request()
    }
  }

  return store.dispatch(logout())
}

export default tokenExpired
